export const ContactUsAvatarGroup = () => (
  <img src="/next-assets/images/cohort/le-contact-avatars.png" alt="Loan Experts" />
);
